import { createFileRoute, redirect } from "@tanstack/react-router"

import { AuthenticatedLayout } from "@/components/layout/authenticated-layout"
import { clearPendingInvite, readPendingInvite } from "@/features/invitations/pending-invite-store"
import { ensureMe, sessionJwtClaims } from "@/lib/me-loader"
import { requireAuth } from "@/lib/route-guards"

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ context }) => {
    await requireAuth(context)
    // Post-login intent: whatever Clerk landed on after sign-in/sign-up, a stashed invite for
    // THIS email goes through `/invite/$token` first (accept, then dashboard). Decided from the
    // session JWT's email claim, BEFORE `/api/users/me` — that call resolves a tenant, which is
    // what provisions a new user's own account, and an invitee must accept before that happens.
    // A stash for a different email is someone else's leftover — drop it, never bounce.
    const pending = readPendingInvite()
    if (pending != null) {
      const token = await context.auth.getToken()
      const jwtEmail = token ? sessionJwtClaims(token).email : null
      // No usable claim (template drift): still go to the invite page — it compares against
      // Clerk's user object without ever calling `/me`, so nothing gets provisioned first.
      if (jwtEmail == null || jwtEmail.trim().toLowerCase() === pending.email) {
        throw redirect({ to: "/invite/$token", params: { token: pending.token } })
      }
      clearPendingInvite()
    }
    // Load `/api/users/me` before the shell so lazy DB provisioning runs before other requests.
    await ensureMe(context)
  },
  component: AuthenticatedLayout,
})
